import { useEffect } from 'react';

interface SeoOptions {
  title: string;
  description: string;
  keywords: string;
  canonicalPath?: string;
  image?: string;
  type?: 'website' | 'article';
}

const SITE_NAME = '91大神影视平台';

const upsertMeta = (key: 'name' | 'property', value: string, content: string) => {
  let el = document.head.querySelector(`meta[${key}="${value}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(key, value);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const upsertLink = (rel: string, href: string) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export function useSeo({ title, description, keywords, canonicalPath, image, type = 'website' }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    upsertMeta('name', 'description', description);
    upsertMeta('name', 'keywords', keywords);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:site_name', SITE_NAME);
    upsertMeta('property', 'og:type', type);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    if (canonicalPath) {
      const base = `${window.location.origin}${__BASE_PATH__.replace(/\/$/, '')}`;
      const url = `${base}${canonicalPath}`;
      upsertLink('canonical', url);
      upsertMeta('property', 'og:url', url);
    }
    if (image) {
      upsertMeta('property', 'og:image', image);
      upsertMeta('name', 'twitter:image', image);
    }
  }, [title, description, keywords, canonicalPath, image, type]);
}